import * as React from 'react';

import accountIconSetMap from './iconSvgMap';
import accountIconNames from './iconNames';
import { IconSet, IBaseIconSet } from '../icon-set/IconSet';

const AccountIconSet = (props: IBaseIconSet) => {
    return <IconSet iconSetMap={accountIconSetMap} {...props} />;
};

export { AccountIconSet, accountIconNames };
